export const removeBodyWheelchairClass = () =>
  document.body.classList.remove("wheelchair-mode")

export const addBodyWheelchairClass = () => {
  document.body.classList.add("wheelchair-mode")
}
